<div class="container">
    <div class="icon">
        <cds-icon
            *ngIf="toastPackage.toastType === 'toast-success'"
            shape="success-standard"
            status="success"
        ></cds-icon>
        <cds-icon
            *ngIf="toastPackage.toastType === 'toast-info'"
            shape="info-standard"
            status="info"
        ></cds-icon>
        <cds-icon
            *ngIf="toastPackage.toastType === 'toast-warning'"
            shape="warning-standard"
            status="warning"
        ></cds-icon>
        <cds-icon
            *ngIf="toastPackage.toastType === 'toast-error'"
            shape="error-standard"
            status="danger"
        ></cds-icon>
    </div>

    <div class="content">
        <div *ngIf="title" class="title" [attr.aria-label]="title">
            {{ title }}
            <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
        </div>

        <div
            *ngIf="message && options.enableHtml"
            role="alert"
            class="message"
            [innerHTML]="message"
        ></div>
        <div
            *ngIf="message && !options.enableHtml"
            role="alert"
            class="message"
            [attr.aria-label]="message"
        >
            {{ message }}
        </div>
    </div>

    <button
        *ngIf="options.closeButton"
        (click)="remove()"
        aria-label="Close"
        class="icon-button icon-medium close-button"
    >
        <cds-icon shape="window-close"></cds-icon>
    </button>

    <div *ngIf="options.progressBar">
        <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
</div>
